import AppFeature from './app-feature.entity';
import { SosUpdateResponse } from '../sos-response';

export interface AppFeatureUpdateResponse extends SosUpdateResponse {
	updated: {
		AppFeature: AppFeature[];
	};
}
